import React from 'react';

const TimeRangeSelector = ({ timeRange, setTimeRange, ranges = null }) => {
  const timeRanges = ranges || [
    { value: '1day', label: 'Вчера' },
    { value: '7days', label: '7 дней' },
    { value: '30days', label: '30 дней' },
    { value: '90days', label: '90 дней' }
  ];

  return (
    <div className="flex justify-end">
      <div className="flex items-center gap-2">
        {timeRanges.map(range => (
          <button
            key={range.value}
            onClick={() => setTimeRange(range.value)}
            className={`px-3 py-1.5 text-xs font-medium rounded-lg transition ${
              timeRange === range.value
                ? 'bg-primary-500 text-white'
                : 'bg-gray-100 dark:bg-dark-800 text-gray-600 dark:text-dark-400 hover:bg-gray-200 dark:hover:bg-dark-700'
            }`}
          >
            {range.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeRangeSelector;
